<template>
  <div class="col-lg-3 col-sm-3 boton-panel" >
    <md-card md-with-hover md-theme="inverso">
      <md-ripple>
        <md-card-media-actions>
          <md-card-header>
            <div  :class="{ 'seleccionado': seleccion }"><b>{{ datos.dt2 }}</b></div>
            <div class="md-subhead" v-if="datos.ndt3"><span>${{ puntos(datos.ndt3) }}</span></div>
          </md-card-header>
          <md-card-actions>
            <div>
              <md-checkbox :value="true" v-model="seleccion" v-on:change="seleccionar"/>
            </div>
          </md-card-actions>
        </md-card-media-actions>
      </md-ripple>
    </md-card>
  </div>
</template>

<script>
import VLazyImage from "v-lazy-image";
import constantes from "../constantes";

export default {
  name: "boton-accesorio",
  data: () => ({
    api: process.env.VUE_APP_URL_API,
    spiner: require("../assets/images/default_paquete.jpg"),
    vermas: false,
    seleccion: false,
    imagen: null,
    html: null,
    valor: []
  }),
  props: {
    datos: {
      type: Object,
      default: () => ({
        id: null,
        elements2: []
      })
    },
    value: {
      type: Array,
      default: () => ([])
    }
  },
  components: {
    VLazyImage
  },
  computed: {
    myBar: function () {
      return Object.assign({}, this.datos)
    }
  },
  methods: {
    minusculas: (texto) => constantes.funciones.minusculas(texto),
    puntos: (numero) => constantes.funciones.puntoMilesDecimal(numero),
    seleccionar: function () {
      let pose = this.valor.find(item => item.dt2 === this.datos.dt2);
      if (pose ) {
        let index = this.valor.findIndex(x => x === pose)
        this.valor.splice(index, 1);
        this.seleccion = false;
      } else {
        this.valor.push(this.datos);
        this.seleccion = true;
      }
      this.$emit('input', this.valor);
    }

  },
  created() {
    this.valor = this.value;
    let pose = this.value.findIndex(item => item.id === this.datos.id);
    this.seleccion = pose >= 0;

  },
}
</script>

<style scoped>
.boton-panel {
  padding-bottom: 15px;
}

.font-italic {
  white-space: pre-wrap;
  font-size: 12px;
}

.md-title {
  font-size: 1.2rem;
}

.v-lazy-image {
  filter: blur(30px);
  transition: filter 0.8s;
}

.v-lazy-image-loaded {
  filter: blur(0);
}

.precio::before {
  vertical-align: super;
  font-size: 0.55em;
  content: '$';
}

.contenedor {
  position: relative;
  display: inline-block;
  text-align: center;
}

.texto-arriba {
  position: absolute;
  top: 10px;
  left: 17px;
  z-index: 1;
  background-color: black;
  color: white;
  white-space: pre-wrap;
  padding: 3px;
}

.seleccionado {
  font-size: 1.5rem; 
  color: black; 
  font-family: kia_bold
}



</style>
